"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Image = _interopRequireDefault(require("../Image"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _addonCard = _interopRequireDefault(require("./addonCard.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CardContainer = _styledComponents.default.div.withConfig({
  displayName: "AddonCard__CardContainer",
  componentId: "sc-4ckmr7-0"
})(["height:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;padding:", ";gap:", ";border:", ";box-shadow:0px 1px 1px rgba(0,0,0,0.2);border-radius:", ";cursor:pointer;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? "".concat(_constant.DIMENSIONS.mobile.height) : "".concat(_constant.DIMENSIONS.desktop.height);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.tiny, "  ").concat(theme.space.small);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.tiny);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "1px solid ".concat(theme.colors.greyMediumLight);
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.borderRadius.normal);
});

var WrapperIncon = _styledComponents.default.div.withConfig({
  displayName: "AddonCard__WrapperIncon",
  componentId: "sc-4ckmr7-1"
})([""]);

var WrapperLabel = _styledComponents.default.div.withConfig({
  displayName: "AddonCard__WrapperLabel",
  componentId: "sc-4ckmr7-2"
})(["font-family:", ";font-size:", ";line-height:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily.default;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.small;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeight.titleSmall;
});

var renderLabel = function renderLabel(label, language) {
  return language[label];
};

var getImage = function getImage(type, imgUrl) {
  var logo = _constant.IMAGE_TYPE[type];
  var src = imgUrl || logo.src;
  return /*#__PURE__*/_react.default.createElement(_Image.default, {
    centerFocus: false,
    placeHolderBackground: "none",
    src: src,
    height: logo.height,
    width: logo.width,
    alt: logo.alt
  });
};

var AddonCard = function AddonCard(_ref9) {
  var label = _ref9.label,
      type = _ref9.type,
      addOnClick = _ref9.addOnClick,
      imgUrl = _ref9.imgUrl,
      theme = _ref9.theme,
      translation = _ref9.translation,
      isloading = _ref9.isloading;

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var getLable = (0, _react.useCallback)(renderLabel, [label]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!isloading) {
      setSelected(null);
    }
  }, [isloading]);

  var handleClick = function handleClick() {
    setSelected(true);
    addOnClick(label);
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(CardContainer, {
    onClick: handleClick
  }, isloading && selected ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animationDuration: "1s",
    color: "primary",
    height: "18px",
    show: true,
    strokeWidth: "3",
    theme: "AIRASIA_CLASSIC",
    width: "18px"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, type && /*#__PURE__*/_react.default.createElement(WrapperIncon, null, getImage(type, imgUrl)), /*#__PURE__*/_react.default.createElement(WrapperLabel, null, getLable(label, language)))));
};

AddonCard.propTypes = _addonCard.default.PropTypes;
AddonCard.defaultProps = _addonCard.default.DefaultProps;
var _default = AddonCard;
exports.default = _default;